import axios from 'axios';

export default {
  // login: async (user, password) => {
  //   const url = `token/login/`;
  //   const data = new FormData();
  //   data.set('user', user);
  //   data.set('password', password);
  //   const response = await axios.post(url, data);
  //   return response.data;
  // },
  login: async (creds) => {
    const url = `/rest-auth/login/`;
    const response = await axios.post(url, creds);
    return response.data;
  },

  get: async (token) => {
    const url = `token/${token}/`;
    const response = await axios.get(url);
    return response.data;
  },
};
